import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { lowerCase } from 'lodash';
import Autosuggest from 'react-autosuggest';
import { translate } from '@td/shared_utils';

import { RefState } from '../../types/refState';
import { SearchIcon } from '../../../icons';

const StateAutocomplete = ({ refStates, onStateSelected, selectedStates }) => {
  const [search, setSearch] = useState('');

  const availableStates = useMemo(
    () =>
      refStates.filter(refState => !selectedStates.some(selectedState => selectedState.stateCd === refState.stateCd)),
    [refStates, selectedStates]
  );

  const [suggestions, setSuggestions] = useState(availableStates);

  return (
    <div className="search-state">
      <div className="input-container">
        <SearchIcon className="input-icon" />
        <Autosuggest
          id="state-autosuggest"
          suggestions={suggestions}
          getSuggestionValue={suggestion => suggestion.stateName}
          renderSuggestion={suggestion => suggestion.stateName}
          focusInputOnSuggestionClick={false}
          onSuggestionsFetchRequested={({ value }) =>
            setSuggestions(availableStates.filter(refState => lowerCase(refState.stateName).includes(lowerCase(value))))
          }
          onSuggestionsClearRequested={() => setSuggestions(availableStates)}
          onSuggestionSelected={(_event, { suggestion }) => {
            setSearch('');

            onStateSelected(suggestion);
          }}
          inputProps={{
            onChange: (_event, { newValue }) => setSearch(newValue),
            value: search,
            placeholder: translate(
              null,
              'medication_formularies.details.availability.edit_form.state_search',
              'placeholder'
            ),
            type: 'search'
          }}
          shouldRenderSuggestions={() => true}
        />
      </div>
    </div>
  );
};

StateAutocomplete.propTypes = {
  refStates: PropTypes.arrayOf(RefState).isRequired,
  selectedStates: PropTypes.arrayOf(RefState).isRequired,
  onStateSelected: PropTypes.func.isRequired
};

export default StateAutocomplete;
